<app-header (ritualPraxisClick)="onRitualCreate()"></app-header>

<style>
  .chart-card {
    display: flex;
    justify-content: center;
  }

  .spinner-container {
    text-align: center;
    color: #fff;
  }

  .spinner {
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top: 4px solid #ffffff;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
    margin: 0 auto 15px auto;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .error-container {
    text-align: center;
    color: #ff8a8a;
  }

  .error-container .chart-action-button {
    margin-top: 15px;
    padding: 10px 20px;
    border: 1px solid #ffffff;
    background-color: transparent;
    color: #ffffff;
    border-radius: 5px;
    cursor: pointer;
  }

  .no-members-message {
    text-align: center;
    margin-top: 50px;
    color: #fff;
  }

  .progress-ring {
    position: relative;
    display: inline-block;
  }

  .progress-ring svg {
    /* Rotate the entire SVG to make the progress start at the top (12 o'clock) */
    transform: rotate(-90deg);
  }

  .progress-ring-circle {
    /* This is crucial: we only want the outline, not a filled circle */
    fill: transparent;
    /* Define the thickness of the ring */
    stroke-width: 8;
    /* Makes the ends of the stroke line rounded */
    stroke-linecap: round;
  }

  /* Style for the grey background ring */
  .progress-ring-bg {
    stroke: #e6e6e6; /* A light grey color */
  }

  /* Style for the moving progress ring */
  .progress-ring-progress {
    stroke: #f59e0b; /* A nice orange/gold color */
    /* Add a smooth animation when the value changes */
    transition: stroke-dashoffset 0.5s ease-in-out;

    /* Calculate circumference: 2 * π * radius (30) = 188.5 */
    stroke-dasharray: 188.5;

    /* Default to empty circle (fully offset) */
    stroke-dashoffset: 188.5;
  }

  .progress-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1.25rem;
    font-weight: bold;
    color: #333;
  }

  /* Dynamic progress states based on completed_main_user percentage */

  /* 0% - Empty circle */
  .progress-ring[data-progress="0"] .progress-ring-progress {
    stroke-dashoffset: 188.5;
  }

  /* 10% */
  .progress-ring[data-progress="10"] .progress-ring-progress {
    stroke-dashoffset: 169.65; /* 188.5 - (188.5 * 0.1) */
  }

  /* 20% */
  .progress-ring[data-progress="20"] .progress-ring-progress {
    stroke-dashoffset: 150.8; /* 188.5 - (188.5 * 0.2) */
  }

  /* 30% */
  .progress-ring[data-progress="30"] .progress-ring-progress {
    stroke-dashoffset: 131.95; /* 188.5 - (188.5 * 0.3) */
  }

  /* 40% */
  .progress-ring[data-progress="40"] .progress-ring-progress {
    stroke-dashoffset: 113.1; /* 188.5 - (188.5 * 0.4) */
  }

  /* 50% */
  .progress-ring[data-progress="50"] .progress-ring-progress {
    stroke-dashoffset: 94.25; /* 188.5 - (188.5 * 0.5) */
  }

  /* 60% */
  .progress-ring[data-progress="60"] .progress-ring-progress {
    stroke-dashoffset: 75.4; /* 188.5 - (188.5 * 0.6) */
  }

  /* 70% */
  .progress-ring[data-progress="70"] .progress-ring-progress {
    stroke-dashoffset: 56.55; /* 188.5 - (188.5 * 0.7) */
  }

  /* 80% */
  .progress-ring[data-progress="80"] .progress-ring-progress {
    stroke-dashoffset: 37.7; /* 188.5 - (188.5 * 0.8) */
  }

  /* 90% */
  .progress-ring[data-progress="90"] .progress-ring-progress {
    stroke-dashoffset: 18.85; /* 188.5 - (188.5 * 0.9) */
  }

  /* 100% - Complete circle */
  .progress-ring[data-progress="100"] .progress-ring-progress {
    stroke-dashoffset: 0;
  }

  /* Continue pattern for 26-99% as needed */
  /* .progress-ring[data-progress="96"] .progress-ring-progress { stroke-dashoffset: 7.54; }
.progress-ring[data-progress="97"] .progress-ring-progress { stroke-dashoffset: 5.655; }
.progress-ring[data-progress="98"] .progress-ring-progress { stroke-dashoffset: 3.77; }
.progress-ring[data-progress="99"] .progress-ring-progress { stroke-dashoffset: 1.885; } */

  /* Alternative: Dynamic CSS Custom Properties approach */
  /* .progress-ring-dynamic {
  --progress-value: 0;
  --circumference: 188.5;
} */

  /* .progress-ring-dynamic .progress-ring-progress {
  stroke-dasharray: var(--circumference);
  stroke-dashoffset: calc(var(--circumference) - (var(--circumference) * var(--progress-value) / 100));
}
  */

  .spinner-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 50px 20px;
    text-align: center;
    color: #f07d12;
  }

  .spinner {
    width: 50px;
    height: 50px;
    border: 5px solid #df8d13; /* Light grey circle */
    border-top: 5px solid #eeeb51; /* Blue spinning part */
    border-radius: 50%;
    animation: spin 1s linear infinite; /* Animation definition */
    margin-bottom: 15px;
  }

  /* This is the animation logic */
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
<div class="mainwrapper">
  <div class="new-container admin_dashboard_list perrenial_dashboard_container">
    <app-login-info></app-login-info>

    <div class="Perennial_mandalism_mail">
      <ng-container *ngIf="subscribeLoader">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-container>
      <div class="data_section_main" *ngIf="memberShipData">
        <div class="data_sec_wrpr">
          <div class="all_data_sub_wrpr_sec">
            <img
              src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/perennial_mandalism/mail_icon_img.webp"
            />
            <h5><strong>Email:</strong> {{ memberShipData.email }}</h5>
          </div>
          <div class="all_data_sub_wrpr_sec">
            <img
              src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/perennial_mandalism/membership_type_icon_img.webp"
            />
            <h5>
              <strong>Membership Type:</strong>
              {{ memberShipData.membership_type }}
            </h5>
          </div>
          <div class="all_data_sub_wrpr_sec">
            <img
              src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/people.png"
            />
            <!-- <h5>
              <strong>Total Members:</strong>
              {{ memberShipData.memberCount <= 0 ? 1 : memberShipData.memberCount }}<i
                (click)="redirecttoAditionalpage()" class="fa fa-pencil" aria-hidden="true"></i>
            </h5> -->

            <h5>
              <strong>Total Members:</strong>
              {{
                memberShipData.memberCount > 0
                  ? memberShipData.memberCount
                  : "Not Added"
              }}
              <i
                (click)="redirecttoAditionalpage()"
                class="fa fa-pencil"
                aria-hidden="true"
              ></i>
            </h5>
          </div>
          <div class="all_data_sub_wrpr_sec">
            <img
              src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/perennial_mandalism/amount_icon_img.webp"
            />
            <h5><strong>Amount:</strong> ${{ memberShipData.amount }}/month</h5>
          </div>
          <div class="all_data_sub_wrpr_sec">
            <img
              src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/perennial_mandalism/created_date_icon_img.webp"
            />
            <h5>
              <strong>Created Date:</strong>
              {{
                memberShipData.created_date
                  | date : "EEEE, MMMM d, y, h:mm:ss a"
              }}
            </h5>
          </div>
          <div class="all_data_sub_wrpr_sec">
            <img
              src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/perennial_mandalism/created_date_icon_img.webp"
            />
            <h5>
              <strong>Subscription Renewal Date:</strong>
              {{
                cookieData?.userinfo?.perennial_current_period_end
                  | date : "EEEE, MMMM d, y"
              }}
            </h5>
          </div>
          <div
            *ngIf="!cookieData?.userinfo?.perennial_subscription_id"
            class="all_data_sub_wrpr_sec"
          >
            <img
              src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/perennial_mandalism/subs_status.webp"
            />
            <h5>
              <strong>Status Confirmation:</strong>
              {{
                cookieData?.userinfo?.perennial_mandalism_status ==
                "subscription running"
                  ? "Your Perennial Access is Active"
                  : "Your Perennial Access is Inactive"
              }}
            </h5>
          </div>

          <div
            *ngIf="
              cookieData?.userinfo?.perennial_subscription_id &&
              cookieData?.userinfo?.perennial_subscription_status
            "
            class="all_data_sub_wrpr_sec"
          >
            <button
              mat-raised-button
              class="subscribed_btn"
              (click)="unsubscribeOpen()"
            >
              Subscribed
            </button>
          </div>
          <div
            *ngIf="
              cookieData?.userinfo?.perennial_subscription_id &&
              !cookieData?.userinfo?.perennial_subscription_status
            "
            class="all_data_sub_wrpr_sec"
          >
            <button
              mat-raised-button
              class="subscribe_btn"
              (click)="subscribeOpen()"
            >
              Subscribe
            </button>
          </div>
        </div>
      </div>

      <div class="astrologertarotcer">
        <div class="astrologertarotcer_ATC_B1_sub">
          <h4 class="header">Support the Eternal Flame of Divine Wisdom</h4>

          <p>
            Your generous offering sustains the ancient arts of astrology,
            tarot, and divine theurgy, empowering seekers to connect with the
            infinite. Through your support, our Mystery School thrives, the
            rituals of the gods are preserved, and the timeless practice of
            Perennial Mandalism flourishes. Together, we weave the threads of
            celestial knowledge and spiritual awakening.
          </p>

          <div _ngcontent-ng-c3905170804="" class="pdashboard_button_wrapper">
            <button _ngcontent-ng-c3905170804="">Donate Now</button>
          </div>
        </div>
      </div>

      <div
        class="new_blockheader"
        *ngIf="!this.cookieData.userinfo.is_mystery_school"
      >
        <div class="new_blockheader_wrpr">
          <div class="new_blockheader_wrprinner">
            <h4>Enter the Sacred Gateway of the Mystery School</h4>
            <h5>
              Awaken your divine potential through transformative training in
              astrology, tarot, and theurgy. Our courses are delivered via live
              stream sessions, in-depth training videos, and collaborative
              reading opportunities with fellow students. You’ll engage directly
              with expert instructors, participate in breakout sessions for
              deeper exploration, and enjoy lifetime access to all course
              materials
              <strong class="subscription-price"
                >for just $10 per month, per user</strong
              >.
            </h5>
            <h6>
              We are now enrolling for our 2025 Grand Opening, with access to
              the training center beginning December 21st, 2025. Seats are
              limited due to live training schedules, so we encourage early
              registration to secure your place in this sacred journey.
            </h6>

            <div class="pdashboard_button_wrapper">
              <button (click)="registerClick()">
                Register for the Mystery School
              </button>
            </div>
          </div>
        </div>
      </div>
      

      <!-- <div class="search_card_wrapper">
        <div class="datepicker_wrapper list-style2">
          <div class="adminlisttable_v2">
            <div class="togglesearchcls">
              <mat-toolbar-row class="mat-toolbar-row searchbar listmaindivbody">
                <mat-form-field appearance="outline">
                  <mat-label>Content Added From (Start Date)</mat-label>
                  <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate" readonly />
                  <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                  <mat-datepicker #startPicker></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Content Added To (End Date)</mat-label>
                  <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate" [min]="startDate" readonly />
                  <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                  <mat-datepicker #endPicker></mat-datepicker>
                </mat-form-field>

                <div class="searchbtncls">
                  <span class="search_class">
                    <mat-icon matTooltip="Refresh" (click)="refreshFields()">refresh</mat-icon>
                    <button matTooltip="Search" mat-icon-button (click)="search()"></button>
                  </span>
                </div>
              </mat-toolbar-row>
            </div>
          </div>
        </div>

        <div class="orders-container">
          <div class="order-card order_card_livestream">
            <div class="order-header">
              <h2>Live Stream</h2>
              <h3>
                {{
                contentCount?.live_stream !== null &&
                contentCount?.live_stream !== undefined
                ? contentCount.live_stream
                : "N/A"
                }}
              </h3>
            </div>
          </div>
          <div class="order-card order_card_videolibrary">
            <div class="order-header">
              <h2>Video Library</h2>
              <h3>
                {{
                contentCount?.video_library !== null &&
                contentCount?.video_library !== undefined
                ? contentCount.video_library
                : "N/A"
                }}
              </h3>
            </div>
          </div>
          <div class="order-card order_card_document">
            <div class="order-header">
              <h2>Document</h2>
              <h3>
                {{
                contentCount?.document !== null &&
                contentCount?.document !== undefined
                ? contentCount.document
                : "N/A"
                }}
              </h3>
            </div>
          </div>
          <div class="order-card order_card_youtubevid">
            <div class="order-header">
              <h2>YouTube Video</h2>
              <h3>
                {{
                contentCount?.youtube_video !== null &&
                contentCount?.youtube_video !== undefined
                ? contentCount.youtube_video
                : "N/A"
                }}
              </h3>
            </div>
          </div>
          <div class="order-card order_card_announcement">
            <div class="order-header">
              <h2>Announcement</h2>
              <h3>
                {{
                contentCount?.announcement !== null &&
                contentCount?.announcement !== undefined
                ? contentCount.announcement
                : "N/A"
                }}
              </h3>
            </div>
          </div>
        </div>
      </div> -->

      <!-- --------------------******New Dashbord Implement*****--------------------- -->

      <div
        class="container perennial-dahboard"
        *ngIf="membersData && membersData.length > 0"
      >
        <div class="profile-status">
          <div
            class="status-card"
            (click)="clickToEditProfile(cookieData.userinfo._id)"
          >
            <div
              class="progress-ring"
              [attr.data-progress]="
                membersData && membersData.length > 0
                  ? membersData[0]['completed_main_user']
                  : 0
              "
            >
              <svg width="80" height="80">
                <circle
                  class="progress-ring-circle progress-ring-bg"
                  cx="40"
                  cy="40"
                  r="30"
                />
                <circle
                  class="progress-ring-circle progress-ring-progress progress-ring-your"
                  cx="40"
                  cy="40"
                  r="30"
                />
              </svg>
              <div
                class="progress-text"
                *ngIf="membersData && membersData.length > 0"
              >
                {{ membersData[0]["completed_main_user"] }}%
              </div>
            </div>
            <div class="status-content">
              <h3>Your Profile</h3>

              <p>Your chart is ready for a deep dive.</p>
            </div>
          </div>

          <div class="status-card">
            <div
              class="progress-ring progress-ring-dynamic"
              [style.--progress-value]="
                membersData && membersData.length > 0
                  ? membersData[0]['completed_main_user']
                  : 0
              "
            >
              <svg width="80" height="80">
                <circle
                  class="progress-ring-circle progress-ring-bg"
                  cx="40"
                  cy="40"
                  r="30"
                />
                <circle
                  class="progress-ring-circle progress-ring-progress progress-ring-your"
                  cx="40"
                  cy="40"
                  r="30"
                />
              </svg>
              <div class="progress-text" *ngIf="otherData">
                {{ otherData.other_percentage }}%
              </div>
            </div>
            <div class="status-content">
              <h3>Members' Profiles</h3>
              <p>Update profiles for relationship analysis.</p>
            </div>
          </div>
        </div>

        <!------------------ Natal Chart Block Structure Implementation----------- -->

        <div class="charts-overview">
          <div class="chart-card">
            <!-- <div *ngIf="isLoading" class="spinner-container">
              <div class="spinner"></div>
              <p>Generating your chart...</p>
            </div> -->

            <!-- <div *ngIf="!isLoading && error" class="error-container">
              <h3>Oops! Something went wrong.</h3>
              <p>{{ error }}</p>
              <button class="chart-action-button" (click)="loadChart()">
                Try Again
              </button>
            </div> -->

            <ng-container *ngIf="!chartData">
              <div class="loading-state-container">
                <mat-spinner></mat-spinner>
                <p>Your natal chart is preparing...</p>
              </div>         
            </ng-container>

            <ng-container *ngIf="chartData">
              <div class="chart-header">
                <h3 class="chart-title">Your Natal Chart</h3>
                <div
                  class="chart-icon icon-transit"
                  matTooltip="A natal chart shows how planets aligned when you were born."
                  [matTooltipShowDelay]="showDelay.value"
                  [matTooltipHideDelay]="hideDelay.value"
                >
                  i
                </div>
              </div>

              <div class="chart-meta">Created: {{ chartData.createdDate }}</div>

              <div class="chart-flx">
                <div class="chart-placeholder">
                  <div
                    (click)="onChartImgClick(chartData.imageUrl)"
                    class="chart-placeholder-img"
                  >
                    <img [src]="chartData.imageUrl" alt="Natal Chart" />
                  </div>
                </div>
                <div class="chart-content">
                  <p>{{ chartData.interpretation }}</p>
                </div>
              </div>

              <div class="chart-action">
                <button (click)="onViewFullChart('western_horoscope_v2')">
                  View Full Chart & Interpretation
                </button>
              </div>
            </ng-container>
          </div>
          <!------------------Monthly Transit Block Implementation----------- -->

          <div class="chart-card">
            <!-- <div *ngIf="isLoading" class="spinner-container">
              <div class="spinner"></div>
              <p>Generating your monthly transit...</p>
            </div> -->
            <!-- <div *ngIf="!isLoading && error" class="error-container">
              <h3>Oops! Something went wrong.</h3>
              <p>{{ error }}</p>
              <button class="chart-action-button" (click)="loadChart()">
                Try Again
              </button>
            </div> -->

            <ng-container *ngIf="!chartData">
              <div class="loading-state-container">
                <mat-spinner></mat-spinner>
                <p>Your monthly transit is generating...</p>
              </div>            
            </ng-container>

            <ng-container *ngIf="monthlyData">
              <div class="chart-header">
                <h3 class="chart-title">Monthly Transit</h3>

                <div
                  class="chart-icon icon-transit"
                  matTooltip="This panel highlights monthly transits, showing how current planetary movements affect your life."
                  [matTooltipShowDelay]="showDelay.value"
                  [matTooltipHideDelay]="hideDelay.value"
                >
                  i
                </div>
              </div>
              <div class="chart-meta">
                Last Generated: {{ monthlyData.createdDate }}
              </div>
              <div class="chart-flx">
                <div class="chart-placeholder">
                  <div
                    (click)="onChartImgClick(monthlyData.imageUrl)"
                    class="chart-placeholder-img"
                  >
                    <img [src]="monthlyData.imageUrl" alt="Natal Chart" />
                  </div>
                </div>
                <div class="chart-content">
                  <p>{{ monthlyData.interpretation }}</p>
                </div>
              </div>

              <div class="chart-action">
                <button
                  (click)="onViewFullChart('tropical_transits_monthly_v3')"
                >
                  View Detailed Transit Report
                </button>
              </div>
            </ng-container>
          </div>

          <!-------------- New Relationship Block Structure Implementation------------- -->
          <!-- <div class="chart-card">
            <div class="chart-header">
              <h3 class="chart-title">Relationship</h3>
              <div
                class="chart-icon icon-transit"
                matTooltip="This block shows the people you've connected with and their relationship to you."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
              >
                i
              </div>
            </div>

            <div class="relationship-meta" *ngIf="membersData.length > 0">
              {{ membersData.length }} Members Connected
            </div>

            <div class="relationship-list">
              <div
                class="relationship-item"
                *ngFor="let member of membersData | slice : 1"
              >
                <div class="relationship-left">
                  <div class="relationship-avatar avatar-arya">
                    {{ getInitials(member.firstname, member.lastname) }}
                  </div>
                  <span class="relationship-name">{{
                    member.firstname + " " + member.lastname | uppercase
                  }}</span>
                </div>
                <div class="relationship-right">
                  <span class="connection-type">{{
                    member.sub_relation | uppercase
                  }}</span>
                </div>
              </div>

              <div
                *ngIf="!membersData || membersData.length <= 1"
                class="no-members-message"
              >
                No other members to display.
              </div>
            </div>

            <div class="chart-action transit-action">
              <button (click)="openCompatibilityTab()">
                Explore Compatibility
              </button>
            </div>
          </div> -->

          <div class="chart-card">
            <div class="chart-header">
              <h3 class="chart-title">Relationship</h3>
              <div
                class="chart-icon icon-transit"
                matTooltip="This block shows the people you've connected with and their relationship to you."
                [matTooltipShowDelay]="showDelay.value"
                [matTooltipHideDelay]="hideDelay.value"
              >
                i
              </div>
            </div>

            <div
              class="relationship-meta"
              *ngIf="membersData && membersData.length > 1"
            >
              {{ membersData.length - 1 }} Members Connected
            </div>

            <div
              class="relationship-list"
              *ngIf="membersData && membersData.length > 1"
            >
              <div
                class="relationship-item"
                *ngFor="let member of membersData | slice : 1"
              >
                <div class="relationship-left">
                  <div class="relationship-avatar avatar-arya">
                    {{ getInitials(member.firstname, member.lastname) }}
                  </div>
                  <span class="relationship-name">{{
                    member.firstname + " " + member.lastname | uppercase
                  }}</span>
                </div>
                <div class="relationship-right">
                  <span class="connection-type">{{
                    member.sub_relation | uppercase
                  }}</span>
                </div>
              </div>
            </div>

            <div
              *ngIf="!membersData || membersData.length <= 1"
              class="no-members-message"
            >
              No other members to display.
            </div>

            <div class="chart-action transit-action">
              <button (click)="openCompatibilityTab()">
                Explore Compatibility
              </button>
            </div>
          </div>
        </div>

        <!------------ Members Block Implementation------------ -->

        <div class="dashboard-container">
          <ng-container *ngIf="subscribeLoader">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </ng-container>
          <button
              (click)="navigateToAddMember()"
              class="add-button"
              matTooltip="Add Members"
              [matTooltipShowDelay]="showDelay.value"
              [matTooltipHideDelay]="hideDelay.value"
          >
            +
          </button>
          <div *ngIf="memberShipData.memberCount > 0" class="header">
            <h1 *ngIf="membersData && membersData.length>0">
              Your Members :
              {{
                memberShipData.memberCount > 0
                  ? memberShipData.memberCount
                  : "Add Members"
              }}
            </h1>
          </div>
          <div
            class="members-list"
            *ngIf="membersData && membersData.length > 0"
          >
            <div
              class="member-card"
              *ngFor="let member of membersData; let i = index"
              [hidden]="i === 0"
            >
              <div class="member-info">
                <div class="member-avatar arya-avatar">
                  {{ getInitials(member.firstname, member.lastname) }}
                </div>

                <div class="member-details">
                  <h3>{{ member.name }}</h3>

                  <p style="color: #f59e0b" *ngIf="member.sub_relation">
                    Relationship: {{ member.sub_relation | uppercase }}
                  </p>
                  <span
                    [ngStyle]="{
                      'font-weight': 'bold',
                      color:
                        member.profile_status === 'Complete'
                          ? '#10b981'
                          : '#ef4444'
                    }"
                  >
                    Profile: {{ member.profile_status }}
                  </span>
                </div>
              </div>

              <button
                class="view-chart-btn"
                (click)="clickToEditProfile(member._id)"
              >
                View Profile
              </button>
            </div>
          </div>

          <div class="nomember-wrap" *ngIf="!loader && membersData && membersData.length <= 1">
            <p>No additional members found.</p>
          </div>

          <!-- <div class="members-list" *ngIf="membersData && membersData.length > 0">
  <div
    class="member-card"
    *ngFor="let member of membersData; let i = index"
    [hidden]="i === 0"
  >
    <div class="member-info">
      <div class="member-avatar arya-avatar">
        {{ getInitials(member.firstname, member.lastname) }}
      </div>

      <div class="member-details">
        <h3>{{ member.name }}</h3>
        <p style="color: #f59e0b">
          Relationship: {{ member.sub_relation | uppercase }}
        </p>
      </div>
    </div>

    <button class="view-chart-btn" (click)="clickToEditProfile(member._id)">
      View Profile
    </button>
  </div>
</div> -->
        </div>
      </div>

      <!-- ------------------------------------********DashBoard End****************-------------------------------------------- -->

      <ng-container *ngIf="loader">
        <div class="content-item loader_wrapper">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      </ng-container>

      <div class="content-container">
        <ng-container *ngIf="!loader">
          <div *ngFor="let item of contentArray" class="content-item">
            <ng-container [ngSwitch]="item.content_type">
              <!-- Video Library (File) -->
              <div *ngSwitchCase="'Video Library'" class="video-library">
                <div class="container-outerwrap">
                  <div class="video-container">
                    <div class="video_iconwrap" *ngIf="!item.isPlaying">
                      <img
                        class="thumbnail_image"
                        [src]="
                          'https://d37pbainmkhx6o.cloudfront.net/' +
                          item.thumbnail_path.baseurl +
                          item.thumbnail_path.fileservername
                        "
                        alt=""
                      />
                      <button class="play_icon" (click)="playVideo(item)">
                        <i class="fa fa-solid fa-play"></i>
                      </button>
                    </div>
                    <video
                      *ngIf="
                        (item.video_source == 'Video File' ||
                          item.video_source == 'Video URL') &&
                        item.isPlaying
                      "
                      controls
                      [autoplay]="item.isPlaying"
                    >
                      <source
                        [src]="
                          item.video_source == 'Video File'
                            ? 'https://d37pbainmkhx6o.cloudfront.net/' +
                              item.file_path.baseurl +
                              item.file_path.fileservername
                            : item.video_url
                        "
                      />
                    </video>
                    <iframe
                      *ngIf="
                        item.video_source == 'YouTube URL' && item.isPlaying
                      "
                      [src]="
                        getSanitizedYouTubeUrlFullUrl(
                          item.youtube_url,
                          item.isPlaying
                        )
                      "
                      width="265"
                      height="150"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
                <div class="content-wrapper">
                  <div class="content-wrapper-inner">
                    <div class="identifier_img">
                      <img
                        src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/video_orange.png"
                        alt=""
                      />
                    </div>
                    <h2>{{ item.title }}</h2>
                  </div>

                  <p>{{ item.description }}</p>
                </div>
              </div>

              <!-- YouTube Video -->
              <div *ngSwitchCase="'YouTube Video'" class="youtube-container">
                <div class="container-outerwrap">
                  <div class="video-container">
                    <div class="video_iconwrap" *ngIf="!item.isPlaying">
                      <img
                        class="thumbnail_image"
                        [src]="
                          'https://d37pbainmkhx6o.cloudfront.net/' +
                          item.thumbnail_path.baseurl +
                          item.thumbnail_path.fileservername
                        "
                        alt=""
                      />
                      <button class="play_icon" (click)="playVideo(item)">
                        <i class="fa fa-solid fa-play"></i>
                      </button>
                    </div>
                    <iframe
                      *ngIf="item.isPlaying"
                      [src]="
                        getSanitizedYouTubeUrlFullUrl(
                          item.youtube_url,
                          item.isPlaying
                        )
                      "
                      width="265"
                      height="150"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>

                <div class="content-wrapper">
                  <div class="content-wrapper-inner">
                    <div class="identifier_img">
                      <img
                        src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/youtube_orange.png"
                        alt=""
                      />
                    </div>
                    <h2>{{ item.title }}</h2>
                  </div>

                  <p>{{ item.description }}</p>
                </div>
              </div>

              <!-- Live Stream -->
              <div *ngSwitchCase="'Live Stream'" class="livestream-container">
                <div class="container-outerwrap">
                  <div class="video-container">
                    <div class="video_iconwrap" *ngIf="!item.isPlaying">
                      <img
                        class="thumbnail_image"
                        [src]="
                          'https://d37pbainmkhx6o.cloudfront.net/' +
                          item.thumbnail_path.baseurl +
                          item.thumbnail_path.fileservername
                        "
                        alt=""
                      />
                      <button class="play_icon" (click)="playVideo(item)">
                        <i class="fa fa-solid fa-play"></i>
                      </button>
                    </div>
                    <ng-container *ngIf="item.stream_source == 0">
                      <video
                        *ngIf="shouldShowVideo(item)"
                        controls
                        [autoplay]="item.isPlaying"
                      >
                        <source [src]="item.direct_url || item.embed_url" />
                      </video>

                      <iframe
                        *ngIf="shouldShowIframe(item)"
                        [src]="
                          getSanitizedYouTubeFullUrlEmbed(
                            item.direct_url || item.embed_url,
                            item.isPlaying
                          )
                        "
                        width="265"
                        height="150"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      ></iframe>
                    </ng-container>
                    <ng-container *ngIf="item.stream_source == 1">
                      <video
                        *ngIf="shouldShowVideo(item)"
                        controls
                        [autoplay]="item.isPlaying"
                      >
                        <source [src]="item.direct_url || item.embed_url" />
                      </video>

                      <iframe
                        *ngIf="shouldShowIframe(item)"
                        [src]="
                          getSanitizedYouTubeUrlFullUrl(
                            item.direct_url || item.embed_url,
                            item.isPlaying
                          )
                        "
                        width="265"
                        height="150"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      ></iframe>
                    </ng-container>
                  </div>
                </div>
                <div class="content-wrapper">
                  <div class="content-wrapper-inner">
                    <div class="identifier_img">
                      <img
                        src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/live-streaming_orange.png"
                        alt=""
                      />
                    </div>
                    <h2>{{ item.title }}</h2>
                  </div>
                  <p>{{ item.description }}</p>
                  <div class="scheduledatetime">
                    <h3>
                      <strong>Premieres On: </strong>
                      {{ item.scheduled_date | date : "yyyy-MM-dd, h:mm a" }}
                    </h3>
                  </div>
                </div>
              </div>

              <!-- Announcement -->
              <div
                *ngSwitchCase="'Announcement'"
                class="announcement-container"
              >
                <div class="container-outerwrap">
                  <div class="video-container">
                    <img
                      [src]="
                        'https://d37pbainmkhx6o.cloudfront.net/' +
                        item.thumbnail_path.baseurl +
                        item.thumbnail_path.fileservername
                      "
                      alt="Announcement"
                      class="announcement-image"
                    />
                  </div>
                </div>

                <div class="content-wrapper">
                  <div class="content-wrapper-inner">
                    <div class="identifier_img">
                      <img
                        src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/announcement_orange.png"
                        alt=""
                      />
                    </div>
                    <h2>{{ item.title }}</h2>
                  </div>
                  <p>{{ item.description }}</p>
                  <span class="announcement_link">
                    <strong>Link: </strong>
                    <a [href]="sanitizeUrlRaw(item.link)" target="_blank">
                      {{ item.link }}</a
                    >
                  </span>
                  <div class="scheduledatetime">
                    <h3>
                      <strong>Starting On: </strong>
                      {{ item.display_startdate | date : "yyyy-MM-dd, h:mm a" }}
                    </h3>
                    <h3>
                      <strong>Ends On: </strong>
                      {{ item.display_enddate | date : "yyyy-MM-dd, h:mm a" }}
                    </h3>
                  </div>
                </div>
              </div>

              <!-- Document -->
              <div *ngSwitchCase="'Document'" class="document-container">
                <div class="container-outerwrap">
                  <div class="video-container">
                    <div class="file_link">
                      <img
                        [src]="
                          'https://d37pbainmkhx6o.cloudfront.net/' +
                          item.thumbnail_path.baseurl +
                          item.thumbnail_path.fileservername
                        "
                        alt="View Document"
                        class="clickable-document-image"
                      />
                      <div
                        class="download-icon"
                        matTooltip="Download File"
                        matTooltipPosition="below"
                        (click)="downloadFile(item)"
                      >
                    </div>
                    </div>
                  </div>
                </div>
                <div class="content-wrapper">
                  <div class="content-wrapper-inner">
                    <div class="identifier_img">
                      <ng-container [ngSwitch]="item.file_path.type">
                        <img
                          *ngSwitchCase="'application/pdf'"
                          src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/pdf-file-orange.png"
                          alt="PDF Icon"
                        />
                        <img
                          *ngSwitchCase="
                            'application/vnd.openxmlformats-officedocument.presentationml.presentation'
                          "
                          src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/ppt-orange.png"
                          alt="PPT Icon"
                        />
                        <img
                          *ngSwitchCase="
                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                          "
                          src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/docx-orange.png"
                          alt="DOCX Icon"
                        />
                        <img
                          *ngSwitchCase="'text/plain'"
                          src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/txt-file-orange.png"
                          alt="TXT Icon"
                        />
                        <img
                          *ngSwitchDefault
                          src="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/perennial_mandalism/document_orange.png"
                          alt="Default Document Icon"
                        />
                      </ng-container>
                    </div>
                    <h2>{{ item.title }}</h2>
                  </div>
                  <p>{{ item.description }}</p>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <div class="astrologertarotcer">
        <div class="astrologertarotcer_ATC_B1_sub">
          <h4 class="header">Support the Eternal Flame of Divine Wisdom</h4>

          <p>
            Your generous offering sustains the ancient arts of astrology,
            tarot, and divine theurgy, empowering seekers to connect with the
            infinite. Through your support, our Mystery School thrives, the
            rituals of the gods are preserved, and the timeless practice of
            Perennial Mandalism flourishes. Together, we weave the threads of
            celestial knowledge and spiritual awakening.
          </p>

          <div _ngcontent-ng-c3905170804="" class="pdashboard_button_wrapper">
            <button _ngcontent-ng-c3905170804="">Donate Now</button>
          </div>
        </div>
      </div>

      <div
        class="new_blockheader"
        *ngIf="!this.cookieData.userinfo.is_mystery_school"
      >
        <div class="new_blockheader_wrpr">
          <div class="new_blockheader_wrprinner">
            <h4>Enter the Sacred Gateway of the Mystery School</h4>
            <h5>
              Awaken your divine potential through transformative training in
              astrology, tarot, and theurgy. Our courses are delivered via live
              stream sessions, in-depth training videos, and collaborative
              reading opportunities with fellow students. You’ll engage directly
              with expert instructors, participate in breakout sessions for
              deeper exploration, and enjoy lifetime access to all course
              materials
              <strong class="subscription-price"
                >for just $10 per month, per user</strong
              >.
            </h5>
            <h6>
              We are now enrolling for our 2025 Grand Opening, with access to
              the training center beginning December 21st, 2025. Seats are
              limited due to live training schedules, so we encourage early
              registration to secure your place in this sacred journey.
            </h6>
            <div class="pdashboard_button_wrapper">
              <button (click)="registerClick()">
                Register for the Mystery School
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
